import React from "react"
import Layout from "../../../components/layout"
import Hero from "../../../components/olympo/hero"
import img from "../../../assets/images/heroOlympoUrbano.png"
import WrapperBlock from "../../../components/olympo/wrapperBlock"
import Block1 from "../../../components/olympo/block1"
import ChasisCompatibles from "../../../components/olympo/chasisCompatibles"
import { OlympoBlock1 } from "../../../data/olympoUrbano"
import { OlympoBlock2 } from "../../../data/olympoUrbano"
import { OlympoBlock3 } from "../../../data/olympoUrbano"
import { OlympoBlock4 } from "../../../data/olympoUrbano"
import { OlympoBlock5 } from "../../../data/olympoUrbano"
const Olympo30 = () => {
  return (
    <Layout
      img={img}
      title="OLYMPO 3.0"
      description="Vehículo para el transporte URBANO de pasajeros. Carrocería LIVIANO, ELEGANTE E INNOVADOR."
    >
      <Hero
        img={img}
        title="OLYMPO 3.0"
        subtitle="Buses urbanos"
        text="
        <li>Vehículo para el transporte <b>URBANO</b> de pasajeros.</li><br/>
        <li>Carrocería <b>LIVIANO, ELEGANTE E INNOVADOR.</b></li>
        "
        crTitle1="Pasajeros sentados"
        crTitle2="Largo"
        crTitle3="Ancho"
        crTitle4="Altura"
        crTitle5="Chasis"
        crText1="28 - 30"
        crText2="9.40 - 9.60 m"
        crText3="2.31 m"
        crText4="3.0 - 3.10 m"
        crText5="Hyundai, Isuzu Intramet, Foton, Mercedes Benz"
        chasisData={[
          { label: "NRO ASIENTOS", values: ["28 - 30", "28 - 30", "28 - 30", "28 - 30"] },
          { label: "NRO PASAJEROS", values: ["27 - 29", "27 - 29", "27 - 29", "27 - 29"] },
          { label: "LARGO", values: ["9.40 - 9.60 mtrs", "9.40 - 9.60 mtrs", "9.40 - 9.60 mtrs", "9.40 - 9.60 mtrs"] },
          { label: "ALTO", values: ["3.0 - 3.10 mtrs", "3.0 - 3.10 mtrs", "3.0 - 3.10 mtrs", "3.0 - 3.10 mtrs"] },
          { label: "ANCHO", values: ["2.31 mtrs", "2.31 mtrs", "2.31 mtrs", "2.31 mtrs"] },
        ]}
      />
      <ChasisCompatibles
        data={[
          { brand: "HYUNDAI", model: "BX11", pdf: "/pdf/HYUNDAI-BX11.pdf" },
          { brand: "ISUZU INTRAMET", model: "ISZ BUS 4500", pdf: "/pdf/ISUZU-4500.pdf" },
          { brand: "FOTON", model: "BJ6730", pdf: "/pdf/FOTON-BJ6730.pdf" },
          { brand: "MERCEDES BENZ", model: "LO-917", pdf: "/pdf/MERCEDES-BENZ-LO-917.pdf" },
        ]}
      />
      <WrapperBlock>
        <Block1 subtitle="SALÓN DE PASAJEROS" data={OlympoBlock1}></Block1>
        <Block1 subtitle="CABINA DE CONDUCTOR" data={OlympoBlock2}></Block1>
        <Block1 subtitle="CONDUCCIÓN" data={OlympoBlock3}></Block1>
        <Block1 subtitle="EXTERIOR" data={OlympoBlock4}></Block1>
        <Block1
          title="CARACTERÍSTICAS OPCIONALES"
          color="gris"
          data={OlympoBlock5}
          backcolor='gris'
        ></Block1>
      </WrapperBlock>
    </Layout>
  )
}

export default Olympo30
